import React, { useCallback, useEffect, useState } from 'react';

import {
  isCurrentPageRedirectFromRNA,
  redirectToOrderSummaryPage,
  redirectToAddHopeThankYouPage,
} from 'common/utilities/utils';
import OrderProcessingViews from 'organisms/orderProcessingViews/container/orderProcessingViews';
import { orderDetailsDefaultValue } from 'common/utilities/orderDetailsUtils';
import { checkOrderTypeIsGiftCardPurchase } from 'common/utilities/orderProcessingSummaryUtils';
import OrderProcessingSummaryHOC from 'components/OrderProcessingSummaryHOC';
import { isAddHopePaymentSuccess, isGiftCardPaymentSuccess } from 'common/utilities/orderStatusUtils';

const OrderProcessing = props => {
  const [orderDetails, setOrderDetails] = useState(orderDetailsDefaultValue);

  /*********************************************************************
   *  updateSetOrderDetails - useCallback
   *  param
   *  console.debug('updateSetOrderDetails => ', param);
   *********************************************************************/
  const updateSetOrderDetails = useCallback(param => {
    setOrderDetails && setOrderDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  /*********************************************************************
   *  useEffect
   *  console.debug('useEffect [] => ', process?.env);
   *********************************************************************/
  useEffect(() => {
    checkOrderTypeIsGiftCardPurchase(props);
    return () => {
      console.debug('useEffect [] return => ');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*********************************************************************
   *  useEffect
   *  orderDetails?.displayOrderProcessingPage
   *  console.debug('useEffect orderDetails?.displayOrderProcessingPage => ', orderDetails?.displayOrderProcessingPage);
   *********************************************************************/
  useEffect(() => {
    if (isAddHopePaymentSuccess(orderDetails)) {
      !orderDetails?.displayOrderProcessingPage && redirectToAddHopeThankYouPage(props);
    } else {
      (!isCurrentPageRedirectFromRNA(props?.history?.location) || isGiftCardPaymentSuccess(orderDetails)) &&
        !orderDetails?.displayOrderProcessingPage &&
        redirectToOrderSummaryPage(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.displayOrderProcessingPage]);

  return (
    <OrderProcessingSummaryHOC {...props} orderDetails={orderDetails} updateSetOrderDetails={updateSetOrderDetails}>
      <OrderProcessingViews {...props} orderDetails={orderDetails} updateSetOrderDetails={updateSetOrderDetails} />
    </OrderProcessingSummaryHOC>
  );
};
export default OrderProcessing;
